import AddGoodInPack from "../components/addGoodInPack/AddGoodInPack"
import Home from "../components/home/Home"
import Login from "../components/login/Login"
import PackBoxes from "../components/pack/boxes/PackBoxes"
import BoxOne from "../components/pack/boxOne/BoxOne"
import Pack from "../components/pack/Pack"
import Page403 from "../components/statuses/403/Page403"
import Supplier from "../components/supply/supplier/Supplier"
import Suppliers from "../components/supply/suppliers/Suppliers"
import SupplyBill from "../components/supply/supplyBill/SupplyBill"
import SupplyBillItemsAll from "../components/supply/supplyBillItemsAll/SupplyBillItemsAll"
import SupplyBills from "../components/supply/supplyBills/SupplyBills"
import SupplyOrder from "../components/supply/supplyOrder/SupplyOrder"
import SupplyOrders from "../components/supply/supplyOrders/SupplyOrders"
import Tasks from "../components/tasks/Tasks"
import UserInfo from "../components/user/info/UserInfo"
import UserSettings from "../components/user/settings/UserSettings"
import UserWorkPlace from "../components/user/workPlace/UserWorkPlace"
import PackingConfirm from "../components/warehouse/confirm/PackingConfirm"
import PackingGoods from "../components/warehouse/packing/PackingGoods"
import WorkPlaceLineWarehouse from "../components/warehouse/workPlaceLine/WorkPlaceLineWarehouse"
import WriteOffAct from "../components/writeOff/act/WriteOffAct"
import WriteOffActs from "../components/writeOff/acts/WriteOffActs"

export const privateRoutes = [
    {path: '/', element: <Home />},
    {path: '/tasks', element: <Tasks />},
    // {path: '/', element: <Tasks />},
    {path: '/production/packs', element: <Pack />},
    {path: '/production/packs/:packId/boxes', element: <PackBoxes />},
    {path: '/production/packs/:packId/boxes/:boxId', element: <BoxOne />},
    {path: '/production/add-good-in-pack', element: <AddGoodInPack />},
    {path: '/warehouse/work-place', element: <WorkPlaceLineWarehouse />},
    {path: '/warehouse/packing', element: <PackingGoods />},
    {path: '/warehouse/confirm', element: <PackingConfirm />},
    {path: '/supply/orders', element: <SupplyOrders />},
    {path: '/supply/orders/:supplyOrderId', element: <SupplyOrder />},
    {path: '/supply/bills', element: <SupplyBills />},
    {path: '/supply/bills/:supplyBillId', element: <SupplyBill />},
    {path: '/supply/bill-items-all', element: <SupplyBillItemsAll />},
    {path: '/supply/suppliers', element: <Suppliers />},
    {path: '/supply/suppliers/:supplierId', element: <Supplier />},
    {path: '/write-off/acts', element: <WriteOffActs />},
    {path: '/write-off/acts/:writeOffActId', element: <WriteOffAct />},
    {path: '/user/work-place', element: <UserWorkPlace />},
    {path: '/user/settings', element: <UserSettings />},
    {path: '/user/info', element: <UserInfo />},
    {path: '403', element: <Page403 />},
]

export const publicRoutes = [
    {path: '/login', element: <Login />},
]